import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const InProgressRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--accounting--payment--in-progress']}>
    <Route index element={<Index />} />
  </SubRouter>
))
